"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorMix = exports.rgb2hex = exports.hex2rgb = exports.assertHex = exports.validateHex = void 0;
const HEX_RE = /[a-f0-9]{6}/;
function validateHex(color) {
    return HEX_RE.test(color.toLowerCase());
}
exports.validateHex = validateHex;
function assertHex(color) {
    if (!validateHex(color)) {
        throw new Error(`Invalid hex color '${color}'`);
    }
}
exports.assertHex = assertHex;
function hex2rgb(color) {
    assertHex(color);
    const rgb = parseInt(color.substring(1).toLowerCase(), 16);
    const r = (rgb >> 16) & 0xFF;
    const g = (rgb >> 8) & 0xFF;
    const b = rgb & 0xFF;
    return [r, g, b];
}
exports.hex2rgb = hex2rgb;
function rgb2hex(rgb) {
    return '#' + rgb.map(c => c.toString(16).padStart(2, '0')).join('');
}
exports.rgb2hex = rgb2hex;
function colorMix(colorA, colorB, mix = 0.5) {
    const rgbA = hex2rgb(colorA);
    const rgbB = hex2rgb(colorB);
    const res = [0, 1, 2].map(i => {
        const c = rgbA[i] * mix + rgbB[i] * (1 - mix);
        return Math.max(0, Math.min(255, Math.floor(c)));
    });
    return rgb2hex(res);
}
exports.colorMix = colorMix;
